import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  Users, Building2, FileText, Tag, Search, Plus, ChevronRight,
  Mail, Phone, MapPin, FileSignature
} from 'lucide-react';

const CustomersTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterBranch, setFilterBranch] = useState('all');

  const customers = [
    { id: 1, name: 'Al Rajhi Trading', type: 'Parent', branches: 4, contacts: 3, contract: true, moq: 'SAR 50,000', pricing: 'Contract A', status: 'Active' },
    { id: 2, name: 'Gulf Distributors', type: 'Parent', branches: 2, contacts: 2, contract: true, moq: 'SAR 30,000', pricing: 'Volume Tier 2', status: 'Active' },
    { id: 3, name: 'Saudi Foods Co', type: 'Single', branches: 1, contacts: 1, contract: true, moq: 'SAR 20,000', pricing: 'Contract B', status: 'Active' },
    { id: 4, name: 'Metro Retail', type: 'Parent', branches: 8, contacts: 5, contract: true, moq: 'SAR 100,000', pricing: 'Enterprise', status: 'Active' },
    { id: 5, name: 'Desert Goods LLC', type: 'Single', branches: 1, contacts: 2, contract: false, moq: 'SAR 10,000', pricing: 'Standard', status: 'Prospect' },
  ];

  const filtered = customers.filter(
    (c) =>
      c.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
      (filterBranch === 'all' || (filterBranch === 'parent' && c.type === 'Parent') || (filterBranch === 'single' && c.type === 'Single'))
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-xl font-semibold text-gray-900">B2B Customers</h2>
        <div className="flex flex-wrap items-center gap-3">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="text"
              placeholder="Search customers..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500 w-48"
            />
          </div>
          <select
            value={filterBranch}
            onChange={(e) => setFilterBranch(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500"
          >
            <option value="all">All</option>
            <option value="parent">Parent only</option>
            <option value="single">Single branch</option>
          </select>
          <button className="inline-flex items-center gap-2 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 text-sm font-medium">
            <Plus className="w-4 h-4" />
            Add Customer
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Branches</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contacts</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contract</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MOQ</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pricing</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filtered.map((c) => (
                <tr key={c.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="h-10 w-10 rounded-full bg-teal-100 flex items-center justify-center">
                        <Building2 className="h-5 w-5 text-teal-600" />
                      </div>
                      <div className="ml-4">
                        <p className="text-sm font-medium text-gray-900">{c.name}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{c.type}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{c.branches}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{c.contacts}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {c.contract ? (
                      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        <FileSignature className="w-3 h-3" /> Yes
                      </span>
                    ) : (
                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">No</span>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{c.moq}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{c.pricing}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${c.status === 'Active' ? 'bg-teal-100 text-teal-800' : 'bg-amber-100 text-amber-800'}`}>
                      {c.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right">
                    <button className="text-teal-600 hover:text-teal-800 p-1">
                      <ChevronRight className="w-5 h-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Customer hub</h3>
        <p className="text-sm text-gray-600 mb-4">
          Manage parent companies, child branches, key contacts, and digital contracts in one place. Custom B2B pricing, volume discounts, and MOQs are applied automatically per customer account.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-4 border border-gray-200 rounded-lg">
            <Building2 className="w-6 h-6 text-teal-600 mb-2" />
            <p className="font-medium text-gray-900">Parent & branches</p>
            <p className="text-xs text-gray-500">Single profile for group entities</p>
          </div>
          <div className="p-4 border border-gray-200 rounded-lg">
            <FileSignature className="w-6 h-6 text-teal-600 mb-2" />
            <p className="font-medium text-gray-900">Contracts & pricing</p>
            <p className="text-xs text-gray-500">Contract pricing and MOQ rules</p>
          </div>
          <div className="p-4 border border-gray-200 rounded-lg">
            <Users className="w-6 h-6 text-teal-600 mb-2" />
            <p className="font-medium text-gray-900">Contacts</p>
            <p className="text-xs text-gray-500">AP, sales, and delivery contacts</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomersTab;
